// import 'lightcase/src/js/lightcase';
// import 'lightcase/src/css/lightcase.css';

(function (root, $, undefined) {

  var sliders = [];

  "use strict";

  $.fn.isInViewport = function (offset) {
    if (offset == null) {
      offset = 0;
    }
    var elementTop = $(this).offset().top + offset;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(function () {

    // Initialization
    is_mobile();
    document.addEventListener("scroll", thisLazyLoad);
    window.addEventListener("resize", thisLazyLoad);
    window.addEventListener("orientationchange", thisLazyLoad);

    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1;
    if (isAndroid) {
      document.body.className += ' is_android';
    }

    if ($('#popupForm').length > 0) {
      form_popup_listener();
    }

    setCommon();
    menu_listener();
    setCommonLoadResize();
    detect_touch();
    checkBannerAnimation();

    // Debounce resize
    $(window).on('resize', function () {
      if (this.resizeTO) clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(function () {
        $(this).trigger('resizeEnd');
      }, 300);
    });

    $(window).on('resizeEnd', function () {
      setCommonLoadResize();
    });

    $(window).on('load', function () {
      $(".acf-map").each(function () {
        initSingleMap($(this));
      });
    });

    $(window).on('load resizeEnd', function () {
      setCommonLoadResize();
    });

    $(document).ajaxComplete(function () {
      thisLazyLoad();
      re_verify_checkbox();
    });

    function setCommon() {
      
      if ($("#popupEbook").length > 0) {
        $("body").on("click", 'a[href^="#ebook"]', function(e) {
            e.preventDefault();
            $('input[name^="ebook-mynet"]').prop("checked", false).closest("label").removeClass("checked");
            var ebook = $(this).data("ebook");
            if (ebook) {
                $('input[value^="' + ebook + '"]').prop("checked", true).closest("label").addClass("checked");
            }
            $("body").addClass("popup_ebook_open");
        });
    
        $("body").on("click", "#closeEbookPopup", function() {
            $("body").removeClass("popup_ebook_open");
        });
    
        $("body").on("click", function(e) {
            if ($(e.target).is("body") && $(e.target).hasClass("popup_ebook_open")) {
                $("body").removeClass("popup_ebook_open");
            }
            if ($(e.target).is("body") && $(e.target).hasClass("open_searchform")) {
                $("body").removeClass("open_searchform");
            }
        });
      }
      
      document.addEventListener("wpcf7submit", function(e) {
          $("body").find(".wpcf7-submit").attr("data-disabled", false);
          setTimeout(function() {
            re_verify_checkbox();
          }, 500);
      }, false);
    
      initLightcase();

      initSwiper();

      setTimeout(function () {
        thisLazyLoad();
      }, 200);

      $('body').on('click', 'label.checkbox', function () {
        var $parent = $(this).find('.wpcf7-list-item');
        var $el = $(this).find('input[type="checkbox"]');
        if ($el.is(':checked')) {
          $parent.addClass('checked');
        } else {
          $parent.removeClass('checked');
        }
      });

      $('body').on('click', '.checkboxes label', function () {
        label_checkbox_toggle($(this));
      });

      $('body').on('click', '.mc4wp-checkbox label', function () {
        label_checkbox_toggle($(this));
      });

      $('body').on('click', '.search_icon a', function () {
        $('body').toggleClass('open_searchform');
      });

      if ($('.animated_image').length >= 1) {
        $('.animated_image:not(.done)').each(function () {
          svgAnimationScrollingBoth($(this));
        });
        document.addEventListener("scroll", function () {
          $('.animated_image').each(function () {
            svgAnimationScrollingBoth($(this));
          });
        });
      }
      $("body").on("click", ".candidati", (function(e) {
        e.preventDefault();
        var a = $(this).data("jobselect");
        thisGoto("#carreer_form", -140);
        $("#job-dropdown").val(a);
      }));
      
      $("body").on("click", ".tabModulo", (function(e) {
        $(".tabModulo").removeClass('active');
        $(".boxModulo").removeClass('active');
        var boxModulo = $(this).data('box');
        $(this).addClass('active');
        $(boxModulo).addClass('active');
        thisLazyLoad();
        
        var ww = window.innerWidth || document.documentElement.clientWidth;
        if(ww < 980.5) {
          thisGoto(".moduliBox", -100);
        }
      }));

      // Add specific function for #banner_home_video
      if ($('#banner_home_video').length > 0) {
        handleBannerHomeVideo();
      }
    }

    function linkVideoSource(video) {
      if(video.hasClass('lazy')) {
        var source = video.find('source');
        var src = source.data('src');
        source.attr('src',src);
        video[0].load();
        video.removeClass('lazy');
      }
    }

    function handleBannerHomeVideo() {
      // Add code specific to #banner_home_video
      var videoBanner = $('#banner_home_video');

      // Play video on scroll into view
      $(window).on('scroll mousemove', function() {
        if (videoBanner.isInViewport()) {
          linkVideoSource(videoBanner);
          videoBanner[0].play();
        } else {
          videoBanner[0].pause();
        }
      });

      // Ensure the video is controlled correctly on resize
      $(window).on('resize', function() {
        if (videoBanner.isInViewport()) {
          linkVideoSource(videoBanner);
          videoBanner[0].play();
        } else {
          videoBanner[0].pause();
        }
      });

    }

    function re_verify_checkbox() {
      $('input[type=checkbox]').each(function () {
        var $el = $(this);
        if ($el.is(':checked')) {
          $el.parent('label').addClass('checked');
          $el.parent('.wpcf7-list-item').addClass('checked');
        } else {
          $el.parent('label').removeClass('checked');
          $el.parent('.wpcf7-list-item').removeClass('checked');
        }
      });
    }

    function setCommonLoadResize() {
      if ($('#top_bar').length > 0)
        $('#top_bar').css('margin-top', $('#top_bar')[0].scrollHeight * -1);

      $('.container_hidden_roadmap').each(function () {
        var submenu = $(this);
        submenu.css('max-height', submenu[0].scrollHeight);
      });

      $('.wcml-cs-submenu').each(function () {
        var submenu = $(this);
        submenu.css('max-height', submenu[0].scrollHeight);
      });

      $('.sub-menu, .accordion_content').each(function () {
        var submenu = $(this);
        submenu.css('max-height', submenu[0].scrollHeight);
      });
    }

    function label_checkbox_toggle($label) {
      var $parent = $label;
      var $el = $label.find('input[type="checkbox"]');
      if ($el.is(':checked')) {
        $parent.addClass('checked');
      } else {
        $parent.removeClass('checked');
      }
    }

    function isFullInViewport(el) {
			var rect = el[0].getBoundingClientRect();
			return rect.bottom > 0 &&
				rect.right > 0 &&
				rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
				rect.top < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */;
		}

    function parallaxEl(elem){ 
      if(isFullInViewport(elem)){
        var direction = elem.data('direction');
        var factor = elem.data('percentage') ? elem.data('percentage') : 40;
        var srolledPart = $(window).scrollTop(); // - elem.offset().top;
        var maxVal = $(window).height() + elem.outerHeight();
        //  (viewportBottom - elementTop) : maxVal = x : 2;

        if($(window).width() < 530) {
          factor = factor / 3;
        } else if($(window).width() < 768) {
          factor = factor / 2;
        }
        
        var percentage = srolledPart * factor / maxVal;
        
        if(percentage < 0){
          percentage = 0;
        }
        if(direction == 'down') {
          elem[0].style.transform = 'translateY('+ percentage +'%)';
        } else if(direction == 'up') {
          elem[0].style.transform = 'translateY(-'+ percentage +'%)';
        }
      }
    }

    function parallaxEach(){
      $('.parallax_el').each(function(){
        parallaxEl($(this));
      });
    }

    function checkBannerAnimation() {
      if($('.parallax_el').length > 0) {
        parallaxEach();
        document.addEventListener("scroll", parallaxEach);
      }
    }


    function svgAnimationScrollingBoth(this_elem) {
      var this_el = this_elem;

      if (this_el.isInViewport(150)) {
        this_el.find('svg').addClass('start');
        this_el.addClass('done');
      } else {
        this_el.find('svg').removeClass('start');
        this_el.removeClass('done');
      }
    }

    function isIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return true;
      } else {
        return false;
      }
    }

    function form_popup_listener() {
      $('body').on('click', 'a[href*="#contatt"]', function (e) {
        e.preventDefault();
        $('body').addClass('popup_contatti_open');
      });

      $("body").on("click", 'a[href="#rowcontat"]', function(e) {
        e.preventDefault(); // Prevenire il comportamento predefinito del link
    
        // Controlla se esiste l'elemento con ID #rowcontatto
        if ($("#rowcontatto").length > 0) {
            // Rimuove il listener dello scroll
            document.removeEventListener("scroll", openPopupScrolling);
    
            // Esegue la funzione di scorrimento verso l'elemento #rowcontatto
            thisGoto($("#rowcontatto")[0], -100, 1000);
    
            // Ripristina il listener dello scroll dopo 30 secondi
            setTimeout(function() {
                document.addEventListener("scroll", openPopupScrolling);
            }, 30000); // 30 secondi
        }
      });

      document.addEventListener("scroll", openPopupScrolling);

      $("body").on("click", "#buttonCall", (function() {
        var e = new Event("buttonCallClicked");
        document.dispatchEvent(e)
      }));  
      $('body').on('click', '#closeContattiPopup', function () {
        $('body').removeClass('popup_contatti_open');
      });

      $('body').on('click', function (e) {
        if ($(e.target).is('body') && $(e.target).hasClass('popup_contatti_open')) {
          $('body').removeClass('popup_contatti_open');
        }
      });
    }

    function menu_listener() {
      $('a[href="#"],a[href*="#contatti"]').on('click', function (e) {
        e.preventDefault();
      });

      $('.expand_roadmap').on('click', function () {
        var elem = $(this);
        $('.container_hidden_roadmap').toggleClass('open');
        if ($('.container_hidden_roadmap').hasClass('open')) {
          elem.text(elem.data('open'));
        } else {
          elem.text(elem.data('close'));
        }
      });

      $('#openSideBar').on('click', function () {
        $('body').addClass('sidebar_open');
      });

      $('#closeSideBar').on('click', function () {
        $('body').removeClass('sidebar_open');
      });

      $('body').on('click', function (e) {
        if ($(e.target).is('body') && $(e.target).hasClass('open_searchform')) {
          $('body').removeClass('open_searchform');
        }
        if ($(e.target).is('body') && $(e.target).hasClass('sidebar_open')) {
          $('body').removeClass('sidebar_open');
        }
        if ($(e.target).is('body') && $(e.target).hasClass('menu_open')) {
          $('body').removeClass('menu_open');
          $('#nav-button').removeClass('open');
          $('ul.menu').removeClass('open_submenu');
          $('li.menu-item').removeClass('open');
        }
      });

      $(".accordionList .accordionTitle").on("click", function(e) {
        var group = $(this).closest('.accordionList');
        var thisItem = $(this).closest('.accordionItem');
        group.find('.accordionItem').removeClass('open');
        thisItem.addClass('open');
      });

      $(".accordion_item").on("click", function(e) {
        var accordionItem = $(this);
        var item = this;
    
        if (!$(e.target).hasClass("video_box")) {
            if (accordionItem.hasClass("open")) {
                if (!$(e.target).hasClass("candidati")) {
                    accordionItem.removeClass("open");
                }
            } else {
                $(".accordion_item").each(function() {
                    $(this).removeClass("open");
                });
                accordionItem.addClass("open");
                thisGoto(item, -100, 1400);
                setTimeout(function() {
                  thisGoto(item, -100, 800);
                }, 500);
            }
        }
      });

      $('#nav-button').on('click', function () {
        if (!$('body').hasClass('menu_open')) {
          $('body').addClass('menu_open');
          $(this).addClass('open');
        } else {
          $('body').removeClass('menu_open').removeClass('open_searchform');
          $('ul.menu').removeClass('open_submenu');
          $('li.menu-item').removeClass('open');
          $(this).removeClass('open');
        }
      });

      if ($('#menu-main-menu > .menu-item-has-children').length > 0) {
        $('#menu-main-menu > .menu-item-has-children').on('click', function (e) {
          var href = '';
          if (typeof e.target.attributes.href !== 'undefined') {
            href = e.target.attributes.href.value;
          }
          if ((e.target.tagName.toLowerCase() !== 'a' && !$('#menu-main-menu > .menu-item-has-children > ul.sub-menu').is(e.target) && $('#menu-main-menu > .menu-item-has-children > ul.sub-menu').has(e.target).length === 0) || (e.target.tagName.toLowerCase() === 'a' && href === '#')) {

            e.preventDefault();

            if ($(this).hasClass('open')) {
              $('ul#menu-main-menu').removeClass('open_submenu');
              $('.menu-item-has-children').removeClass('open');
            } else {
              $('ul#menu-main-menu').addClass('open_submenu');
              $('.menu-item-has-children').removeClass('open');
              $(this).addClass('open');
            }
          }
        });
      }
    }

    function thisLazyLoad() {
      if (typeof lazyLoad === "function") {
        lazyLoad();
      }
    }

    function thisGoto(target, offset, velocity, ease) {
      if (typeof goTo === "function") {
        goTo(target, offset, velocity, ease);
      }
    }

  });

  const initLightcase = () => {

    if ($('.lightcase').length > 0) {
      $('.lightcase').each(function(){
        $(this).attr('data-rel','lightcase');
      });
    }

    if ($("a[data-rel^=lightcase]").length > 0) {
      import("lightcase/src/css/lightcase.css");
      import("lightcase/src/js/lightcase.js").then(() => {
            
        $('a[data-rel^=lightcase]').each(function () {
          var $this = $(this);
          var $attrs = $this.data('lightcase');
          if ($attrs != null && $attrs != "") {
            $($attrs.slice(1, -1)).insertAfter($this);
          }
        });

        if (isMobile) {
          $('a[data-rel^=lightcase]').lightcase({
            video: {
              autoplay: true,
            },
            swipe: true
          });
        } else {
          $('a[data-rel^=lightcase]').lightcase({
            video: {
              autoplay: true,
              width: '1280px',
              height: '720px'
            },
            iframe: {
              width: '1280px',
              height: '720px'
            }
          });
        }
      });
    }

  }

  const initSwiper = () => {
    if ($(".swiper").length > 0) {
      import("swiper/swiper.min.css");
        import("swiper/css/pagination");
        import("swiper/css/navigation");
        import("swiper/css/effect-fade");
        import("swiper/css/thumbs");
      import("swiper")
        .then((module) => {
          module.Swiper.use([
            module.Autoplay,
            module.Navigation,
            module.Pagination,
            module.EffectFade,
            module.Thumbs,
            module.Lazy
          ]);

          $(".swiper").each((index, item) => {
            const data = $(item).data("slideshow");

            // console.log("data", data);
            if (data && data.pagination && !data.pagination.type) {
              data.pagination.renderBullet = (index, className) => {
                return '<span class="' + className + '"></span>';
              };
            }
            if (data && data.pagination && data.pagination.type == 'fraction') {
              data.pagination.renderFraction = (currentClass, totalClass) => {
                return '<span class="' + currentClass + '"></span>';
              };
              data.pagination.formatFractionCurrent = (currentNumber) => {
                return ('0' + currentNumber).slice(-2);
              }
            }

            if (data && !data.disabled) {
              const slider = new module.Swiper(item, {
                ...data
              });
              sliders.push(slider);
            } else {
              $(item).find(".swiper-button-next").hide();
              $(item).find(".swiper-button-prev").hide();
              $(item).find(".swiper-pagination").hide();
            }
          });
        })
        .catch((e) => {
          console.log("Error loasding swiper: ", e);
        });
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    // Funzione per estrarre i parametri dall'URL e salvarli in localStorage
    function saveUtmParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const paramsToSave = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid'];

        paramsToSave.forEach(param => {
            if (urlParams.has(param)) {
                localStorage.setItem(param, urlParams.get(param));
            }
        });
    }

    // Funzione per compilare i campi nascosti del form
    function fillHiddenFields(formId) {
        const form = document.querySelector(`[data-wpcf7-id="${formId}"] form`);
        if (!form) {
            return;
        }

        const paramsToFill = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid'];

        paramsToFill.forEach(param => {
            const hiddenField = form.querySelector(`input[name="${param}"]`);
            if (hiddenField) {
                const storedValue = localStorage.getItem(param);
                if (storedValue) {
                    hiddenField.value = storedValue;
                }
            }
        });
    }

    // Esegui la funzione di salvataggio al caricamento della pagina
    saveUtmParams();

    // Quando un form di CF7 è pronto, compila i campi nascosti
    document.addEventListener('wpcf7mailsent', function(event) {
        // Opzionale: pulisci localStorage dopo l'invio riuscito
        // const paramsToClear = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid'];
        // paramsToClear.forEach(param => localStorage.removeItem(param));
    }, false);

    // Gestisci la compilazione dei campi per uno o più form specifici
    // Sostituisci 'YOUR_FORM_ID_HERE' con l'ID effettivo del tuo form.
    const formIds = ['9627']; // Esempio: ['123', '456']

    formIds.forEach(formId => {
        fillHiddenFields(formId);
    });
  });


  var isMobile = false;

  function is_mobile() {
    if ((/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))) {
      isMobile = true;
    } else {
      isMobile = false;
    }
  }

  // Variabile per controllare se la funzione è già stata eseguita
  var isTriggered = true;

  function openPopupScrolling() {
      // Verifica se il body ha la classe 'openPopupOnScroll'
      if ($("body").hasClass("openPopupOnScroll")) {
          // Altezza della finestra del browser
          var windowHeight = $(window).height();
          
          // Punto medio della finestra, rispetto al documento
          var middleOfWindow = $(window).scrollTop() + windowHeight / 2;
          
          // Punto medio della pagina, considerando l'altezza della finestra
          var middleOfPage = $("body")[0].scrollHeight - windowHeight / 2;
          
          // Se la funzione non è stata ancora eseguita e il punto medio della finestra ha raggiunto il punto medio della pagina
          if (isTriggered && middleOfWindow >= middleOfPage / 2) {
              // Imposta 'isTriggered' su falso per evitare ulteriori esecuzioni
              isTriggered = false;
              
              // Simula un clic su un link con href '#contatti'
              // $('a[href^="#contatti"]').trigger("click");
              $('body').addClass('popup_contatti_open');
          }
      }
  }


  function initSingleMap($el) {
    var styles = $el.data("styles");
    var $markers = $el.find(".marker");
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: styles,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: false,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    centerMap(map);

    return map;
  }

  function initMarker($marker, map) {
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    var image = $(".acf-map").data("marker");

    var icon = {
      url: image,
      // scaledSize: new google.maps.Size(75, 75), // scaled size
      // origin: new google.maps.Point(0, 0), // origin
      // anchor: new google.maps.Point(0, 0), // anchor
    };

    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon,
    });

    map.markers.push(marker);

    if ($marker.html()) {
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  function centerMap(map) {
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
    } else {
      map.fitBounds(bounds);
    }
  }


  function addCookie(name, container) {
    var d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
    var expires = d.toGMTString();
    document.cookie = name + "=true; expires=" + expires + "; path=/";
    var element = document.getElementById(container);
    element.classList.add("closed");
  }

  function getScrollBarWidth() {
    if (jQuery(document).height() > jQuery(window).height()) {
      jQuery('body').append('<div id="fakescrollbar" style="width:50px;height:50px;overflow:hidden;position:absolute;top:-200px;left:-200px;"></div>');
      var fakeScrollBar = jQuery('#fakescrollbar');
      fakeScrollBar.append('<div style="height:100px;">&nbsp;</div>');
      var w1 = fakeScrollBar.find('div').innerWidth();
      fakeScrollBar.css('overflow-y', 'scroll');
      var w2 = jQuery('#fakescrollbar').find('div').html('html is required to init new width.').innerWidth();
      fakeScrollBar.remove();
      return (w1 - w2);
    }
    return 0;
  }

  function detect_touch() {
    if ("ontouchstart" in window) {
      document.documentElement.className = document.documentElement.className + " touch";
    }
  }

}(this, jQuery));
